import Container from '@/components/atoms/Container'
import Search from '@/components/atoms/Search'
import Select from '@/components/atoms/Select'
import Spinner from '@/components/atoms/Spinner'
import { CardMentor } from '@/components/molecules/Admin/Cards/CardMentor'
import mentorsService from '@/services/mentorsService'
import { useAppSelector } from '@/store/hooks'
import { MentorsModel } from '@models'
import { useEffect, useState } from 'react'

const optionsTag = [
	{ label: 'Todos', value: '' },
	{
		label: 'Devolutiva Inicial',
		value: 'EMPREENDA',
	},
]

const optionsSpecialty = [
	{ label: 'Todos', value: '' },
	{ label: 'Design', value: 'UX' },
	{ label: 'Dados', value: 'DS' },
	{ label: 'Gestão de Produtos', value: 'PM' },
	{ label: 'Programação', value: 'WD' },
	{ label: 'Inovação e Gestão', value: 'SS' },
	{ label: 'Marketing', value: 'MKT' },
	{ label: 'Carreira', value: 'CONSULTANT' },
	{ label: 'Gen IA', value: 'IA' },
	{ label: 'Inglês', value: 'EN' },
]

const optionsHourly = [
	{ label: 'Dias úteis pela manhã', value: 'morning' },
	{ label: 'Dias úteis pela tarde', value: 'evening' },
	{ label: 'Dias úteis pela noite', value: 'night' },
	{ label: 'Fins de semana', value: 'weekend' },
]

export function Hero() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const [page, setPage] = useState(1)

	const [dataMentors, setDataMentors] = useState<MentorsModel.Show[]>([])

	const [inputSearch, setInputSearch] = useState<string>('')

	const [filterSpecialty, setFilterSpecialty] = useState<{
		label?: string
		value?: string
	}>({})

	const [filterTag, setFilterTag] = useState<{
		label?: string
		value?: string
	}>({})

	const [filterHourly, setFilterHourly] = useState<{
		label?: string
		value?: string
	}>({})

	const { data, isLoading, isSuccess } = mentorsService.list({
		page: page.toString(),
		search: inputSearch,
		vertical: filterSpecialty?.value || '',
		availabilities: filterHourly?.value || '',
		tag:
			user?.tag && ['EMPREENDA'].includes(user?.tag.toUpperCase())
				? 'empreenda'
				: filterTag?.value || '',
	})

	useEffect(() => {
		if (isSuccess) {
			if (page > 1) {
				setDataMentors((prevState) => [...prevState, ...(data?.mentors || [])])
			} else {
				setDataMentors(data?.mentors || [])
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data, page, filterSpecialty?.value, filterHourly?.value])

	useEffect(() => {
		setPage(1) // Reseta a página ao mudar o filtro
	}, [filterSpecialty, filterHourly, filterTag, inputSearch])

	useEffect(() => {
		setFilterSpecialty({})
		setFilterTag({})
	}, [inputSearch])

	return (
		<Container className='pb-10'>
			<div className='flex flex-col gap-6 md:gap-8'>
				<div className='flex flex-col gap-2'>
					<h2 className='text-2xl text-white font-medium'>Mentores</h2>
					<h3 className='text-base text-white/70 font-medium'>
						Conheça nosso time de especialistas e agende sessões de mentoria
					</h3>
				</div>
				<div className='flex flex-col gap-10 md:gap-5 w-full max-w-[1020px]'>
					<div className='flex flex-col lg:flex-row gap-4'>
						<div className='flex w-full lg:max-w-[300px]'>
							<Search
								value={inputSearch}
								setSelectedField={setInputSearch}
								placeholder='Busque por um mentor'
							/>
						</div>

						<div className='flex w-full lg:max-w-[230px]'>
							<Select
								selectedField={filterSpecialty}
								setSelectedField={setFilterSpecialty}
								options={optionsSpecialty}
								resetOnClickSelected
								// disabled={!dataMentors?.length}
								placeholder='Especialidades'
								classNameButton='h-[38px] rounded-full'
								classNameOptions='rounded-md z-10 max-h-[300px]'
							/>
						</div>
						<div className='flex w-full lg:max-w-[230px]'>
							<Select
								selectedField={filterHourly}
								setSelectedField={setFilterHourly}
								resetOnClickSelected
								// disabled={!dataMentors?.length}
								options={optionsHourly}
								placeholder='Horários'
								classNameButton='h-[38px] rounded-full'
								classNameOptions='rounded-md z-10'
							/>
						</div>
						<div className='flex w-full lg:max-w-[200px]'>
							<Select
								selectedField={filterTag}
								setSelectedField={setFilterTag}
								options={optionsTag}
								resetOnClickSelected
								// disabled={!dataMentors?.length}
								placeholder='Filtrar por tipo'
								classNameButton='h-[42px] rounded-full'
								classNameOptions='rounded-md z-10 max-h-[500px]'
							/>
						</div>
					</div>
					{(() => {
						if (isLoading) {
							return (
								<div className='flex justify-center'>
									<Spinner
										className={
											'inline w-10 h-10 text-gray-200 animate-spin fill-brand-primary'
										}
									/>
								</div>
							)
						}

						if (dataMentors && dataMentors?.length > 0) {
							return (
								<div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
									{dataMentors?.map((mentor, key) => {
										return <CardMentor mentor={mentor} key={key} />
									})}
								</div>
							)
						}

						return (
							<div className='flex items-center gap-4 py-4'>
								<img
									src='/imgs/admin/courses/empty.png'
									alt='Emoji'
									className='w-auto h-[32px] hidden md:flex'
								/>
								<p className='text-sm leanding-[146%] text-white/70 tracking-wide max-w-[510px]'>
									Nenhum(a) mentor(a) foi encontrado(a).
								</p>
							</div>
						)
					})()}
				</div>
				{dataMentors &&
					dataMentors?.length > 0 &&
					dataMentors?.length !== data?.total && (
						<div className='flex flex-col gap-2 items-end lg:items-start'>
							<div className='flex'>
								<p className='text-sm font-medium text-white/80 leading-[155%]'>
									Quer conferir mais mentores?
								</p>
							</div>
							<div className='flex'>
								{(() => {
									if (dataMentors?.length !== data?.total) {
										return (
											<button
												type='button'
												onClick={() => {
													setPage((current) => current + 1)
												}}
												className='text-sm font-bold leading-[155%] text-white'
											>
												Carregar mais...
											</button>
										)
									}
								})()}
							</div>
						</div>
					)}
			</div>
		</Container>
	)
}
